module.exports = __webpack_public_path__ + "static/christina-yacht-2-1cdf8982ecdf3348c8ba91dbacf952d6.jpg";